module.exports = __webpack_public_path__ + "img/healthPro2-EN.95730773.png";